var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.Comp,
    {
      ref: "operationManageParent",
      tag: "component",
      on: { resetTable: _vm.resetTable },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "top", type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "students" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Danh sách học sinh"),
              ]),
              _c("DataManageStudentPackages", {
                ref: "dataManageStudentPackages",
                attrs: { tab: "class" },
                on: { resetDataFilter: _vm.resetDataFilter },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "packages" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Danh sách gói"),
              ]),
              _c("DataManagePackages", { attrs: { tab: "group" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }